// See https://primevue.org/datepicker/#format
export function localeToPrimeVueDateFormat(locale: string): string {
    const formatter = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
    });

    const parts = formatter.formatToParts(new Date());
    return parts
        .map((part) => {
            switch (part.type) {
                case 'day':
                    return 'dd';
                case 'month':
                    return 'mm';
                case 'year':
                    return 'yy';
                case 'literal':
                    return part.value;
                default:
                    return '';
            }
        })
        .join('');
}
